module.exports = __webpack_public_path__ + "img/1.394e74da.png";